export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "custom.worker.9b540df1bbf8dad328d2-530.worker.js");
}
